@for (symb of symbology; track $index) {
  <div class="color-and-label">
    @if (symb.opacity > 0) {
      <div
        class="color-box"
        [style.background-color]="
          'rgba(' + symb.red + ',' + symb.green + ',' + symb.blue + ',' + symb.opacity + ')'
        "
      ></div>
    } @else {
      <svg width="50" height="12">
        <title>my vector image</title>
        <rect
          id="backgroundrect"
          width="100%"
          height="100%"
          x="0"
          y="0"
          fill="#FFFFFF"
          stroke="none"
        />
        <g class="currentLayer">
          <title>Layer 1</title>
          <path
            fill="#ff0000"
            fill-opacity="1"
            stroke="#ff0000"
            stroke-opacity="1"
            stroke-width="2"
            stroke-linejoin="round"
            stroke-linecap="butt"
            fill-rule="nonzero"
            opacity="1"
            d="M-0.16129168771923474,-0.0000010421198837207157L50.03225520349327,11.741934091814151"
          />
          <path
            fill="#ff0000"
            fill-opacity="1"
            stroke="#ff0000"
            stroke-opacity="1"
            stroke-width="2"
            stroke-linejoin="round"
            stroke-linecap="butt"
            fill-rule="nonzero"
            opacity="1"
            d="M50.03225520349327,-0.1290332963389389L-0.16129168771923474,11.741934091814151"
          />
        </g>
      </svg>
    }

    <div class="label">{{ symb.label }}</div>
  </div>
}
